<template>
    <div>
        <div v-for="(collection, index) in collections" v-show="index < limit" class="book-wrap" @click="$router.push(`/collection/${collection.code}`)">
            <div class="book">
                <div class="front">
                    <div class="cover">
                        <img :src="`/res/shop/categories/${collection._id}/${collection.image}`" alt="">
                        <!-- <p class=author>George Orwell</p> -->
                    </div>
                </div>
                <div class="left-side">
                    <h2>
                        <span>{{ collection.name }}</span>
                        <span>{{ collection.sideText }}</span>
                    </h2>
                </div>
            </div>
            <div class="bottom-content">
                <h1>{{ collection.name }}</h1>
                <div class="hash-div">
                    <div v-for="hashtag in collection.hashtags" type="button" name="button">#{{ hashtag.trim() }}</div>
                </div>
            </div>
        </div>

        <div v-if="limit < collections.length" class="container main-view-more-wrap">
            <button type="button" class="main-view-more" @click="limit += 6" name="button">Load More</button>
        </div>
    </div>
</template>
<script>
export default{
    props: {
        collections: { type: Array, default: [] }
    },
    data: () => {
        return {
            limit: 6,
        };
    },
}
</script>
